import { render, staticRenderFns } from "./ci_resources_list.vue?vue&type=template&id=5d8df2c1&vue3"
import script from "./ci_resources_list.vue?vue&type=script&lang=js&vue3"
export * from "./ci_resources_list.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports